import React, { Component } from "react";
import { Link } from "react-router";

import OrganizationSelect from "../../components/OrganizationSelect";
import SubMeterStore from "../../stores/SubMeterStore";
import SubMeterForm from "../../components/SubMeterForm";
import ApplicationStore from "../../stores/ApplicationStore";

class CreateSubMeter extends Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired
  };

  constructor() {
    super();
    this.state = {
      application: {},
      node: {},
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillMount() {
    ApplicationStore.getApplication(this.props.params.applicationID, (application) => {
      this.setState({application: application});
    });
  }

  onSubmit(node) {
    node.applicationID = this.props.params.applicationID;
    SubMeterStore.createSubMeter(node, (responseData) => {
      this.context.router.push('/organizations/'+this.props.params.organizationID+'/applications/'+this.props.params.applicationID+'/subMeter/list');
    }); 
  }

  render() {
    return (    
      <div>
        <ol className="breadcrumb">
          <li><Link to="/organizations">Organizations</Link></li>
          <li><OrganizationSelect organizationID={this.props.params.organizationID} /></li>
          <li><Link to={`/organizations/${this.props.params.organizationID}/applications`}>Applications</Link></li>
          <li><Link to={`/organizations/${this.props.params.organizationID}/applications/${this.props.params.applicationID}/subMeter/list`}>{this.state.application.name}</Link></li>
          <li className="active">Create node</li>
        </ol>
        <hr />
        <div className="panel panel-default">
          <div className="panel-body">
            <SubMeterForm node={this.state.node} application={this.state.application} onSubmit={this.onSubmit} />
          </div>
        </div>
      </div>
    );
  }
}

export default CreateSubMeter;



// WEBPACK FOOTER //
// ./src/views/submeters/CreateSubMeter.js